module.exports = __webpack_public_path__ + "static/media/grandhyatt-2.53fea40c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Hotel/images/partner-hotels/grand-hyatt/grandhyatt-2.jpg
// module id = 713
// module chunks = 6